import { ApiResponse } from 'apisauce'
import { call, put } from 'redux-saga/effects'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import api from 'src/services/api'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'

import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getPartners({
  payload: { options }
}: ReturnType<typeof Actions.getPartners>) {
  const params = []

  if (options.request_agency_ids && options.request_agency_ids.length) {
    params.push(`request_agency_ids=${options.request_agency_ids.join(',')}`)
  }

  if (options.request_ids && options.request_ids.length) {
    params.push(`request_ids=${options.request_ids.join(',')}`)
  }

  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/partners?${params.join('&')}&page_size=10&page=${options.page || 1}`
    )

    if (response.ok) {
      const { partners } = response.data
      yield put(Actions.getPartnersSuccess({ partners }))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getPartnersFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getPartnersFailure(message))
  }
}

export function* sendPartner({
  payload: { partner }
}: ReturnType<typeof Actions.sendPartner>) {
  try {
    const responsePayload = { partner }
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      '/partners',
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendPartnerSuccess({ response: response.data }))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendPartnerFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendPartner', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendPartnerFailure(message))
  }
}
